import React, { useMemo, useState } from 'react'

import {
  FilterActions,
  InitialFilterState,
  PropertiesFilters as PropertiesFiltersType,
  useFiltersContext,
} from '@/context'

import { ApplyButton, ClearButton, FilterOption } from './components'

type keys = keyof PropertiesFiltersType

type Props = {
  onClose: () => void
}
const PropertiesFilters = ({ onClose }: Props) => {
  const [{ propertiesFilters }, FilterDispatch] = useFiltersContext()
  const [filterOptions, setFilterOptions] = useState(propertiesFilters)

  const onSelectFilter = (selectedOption: { [key in keys]: boolean }) => {
    setFilterOptions({ ...InitialFilterState['propertiesFilters'], ...selectedOption })
  }

  const onApply = () => {
    FilterDispatch(FilterActions.setFilters({ filterName: 'properties', filters: filterOptions }))
    onClose()
  }

  const onClear = () => {
    FilterDispatch(FilterActions.clearFilters({ filterName: 'properties' }))
    onClose()
  }

  const showClearButton = useMemo(() => Object.keys(filterOptions).find((key) => !!filterOptions[key]), [filterOptions])

  return (
    <>
      <FilterOption label="Blocked" name="blocked" onSelect={onSelectFilter} value={filterOptions['blocked']} />
      {showClearButton && <ClearButton onClick={onClear} />}
      <ApplyButton onClick={onApply} />
    </>
  )
}

export default PropertiesFilters
